<template>
  <generic-modal
    size
    :title="$t('deployment')"
    icon="rocket"
    image="/images/icons/deployment.png"
    v-bind:scrolling="false"
    v-on:destroy="destroy"
    v-bind:on_finished="this.finished"
  >
    <div class="description">
      <div class="ui form" ref="form">
        <div class="four fields">
          <div class="field">
            <label for>{{ $t("environment") }}</label>
            <div class="ui selection dropdown" ref="environment_dropdown">
              <input type="hidden" name="environment" />
              <i class="dropdown icon"></i>
              <div class="default text"></div>
              <div class="menu">
                <div class="item" data-value="development">
                  {{ $t("development") }}
                </div>
                <div class="item" data-value="testing">{{ $t("testing") }}</div>
                <div class="item" data-value="production">
                  {{ $t("production") }}
                </div>
              </div>
            </div>
          </div>
          <div class="field">
            <label for>{{ $t("partition target") }}</label>
            <div class="ui selection dropdown" ref="partition_dropdown">
              <input type="hidden" name="partition" />
              <i class="dropdown icon"></i>
              <div class="default text"></div>
              <div class="menu"></div>
            </div>
          </div>
          <div class="field">
            <label for>{{ $t("version") }}</label>
            <input type="text" name="version" v-model="version" />
          </div>
          <div class="field">
            <div class="ui toggle checkbox">
              <input type="checkbox" name="public" v-model="set_default" />
              <label>{{ $t("set as default") }}</label>
            </div>
          </div>
        </div>
        <div class="field">
          <label for>{{ $t("annotation") }}</label>
          <textarea name="annotation" rows="2" v-model="annotation"></textarea>
        </div>
        <div class="ui error message"></div>
      </div>
    </div>
  </generic-modal>
</template>

<script>
import { local_api } from "@/utils";
import GenericModal from "@/components/GenericModal";

export default {
  components: {
    "generic-modal": GenericModal
  },
  computed: {},
  props: { project: Object },
  data() {
    return {
      environment: "",
      partition: "",
      version: "1.0.0",
      annotation: "",
      set_default: true
      // partitions: []
    };
  },
  methods: {
    finished() {
      let vm = this;
      return new Promise(function(resolve, reject) {
        let isValid = window.jQuery(vm.$refs.form).form("validate form");

        if (!isValid) reject();
        else {
          local_api(vm, "post", "/ngine_composer/project/do-deploy", {
            i: vm.project ? vm.project.uuid : undefined,
            p: vm.partition,
            v: vm.version,
            a: vm.annotation,
            d: vm.set_default,
            e: vm.environment
          })
            .then((project) => {
              vm.$alertify.success(vm.$t("project deployed successfully"));
              vm.$emit("succedded", project);
              resolve();
            })
            .catch((err) => {
              reject(err);
            });
        }
      });
    },
    destroy() {
      this.$emit("destroy");
      // this.$destroy();
    }
  },
  mounted() {
    let vm = this;
    window.jQuery(vm.$refs.form).form({
      fields: {
        partition: ["empty"],
        version: ["empty"]
      }
    });

    local_api(this, "post", "/ngine_core/partition/do-get-list")
      .then((partitions) => {
        let _partitions = partitions
          .sort(function(a, b) {
            if (a.name > b.name) return 1;
            if (b.name > a.name) return -1;
            return 0;
          })
          .map((p) => {
            return { name: p.name, value: p.uuid };
          });

        window
          .jQuery(vm.$refs.partition_dropdown)
          .dropdown({
            onChange: function(value) {
              vm.partition = value;
            }
          })
          .dropdown("setup menu", { values: _partitions })
          .dropdown("set selected", "92ee7b1e-1469-41e4-b036-0063644aabfd");
      })
      .catch((err) => {
        window.jQuery(this.$el).toast({
          message: err,
          class: "error",
          showImage: "/images/error.png",
          classImage: "avatar",
          title: "Error",
          showProgress: "bottom",
          classProgress: "blue"
        });
      });

    window
      .jQuery(vm.$refs.environment_dropdown)
      .dropdown({
        onChange: function(value) {
          vm.environment = value;
        }
      })
      .dropdown("set selected", "development");
  },
  watch: {},
  updated: function() {
    this.$nextTick(function() {
      let vm = this;
      window.jQuery(vm.$refs.calendar).calendar({
        type: "date",
        onChange(date) {
          let index = window.jQuery(this).data("index");
          if (index >= 0) vm.attributes[index].value = date;
        }
      });
    });
  }
};
</script>
